import { render, staticRenderFns } from "./follow_count.vue?vue&type=template&id=4c8bf3e2&scoped=true&"
import script from "./follow_count.vue?vue&type=script&lang=js&"
export * from "./follow_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8bf3e2",
  null
  
)

export default component.exports